import { ChainId } from "./types/ChainId"

export const buildAddresses = (
    addresses: Partial<Record<ChainId, string>>,
  ): Record<ChainId, string> => {
    return Object.keys(ChainId).reduce((acc, id) => {
      const numId = Number(id) as ChainId
      return { ...acc, [numId]: addresses?.[numId] || "" }
    }, {}) as Record<ChainId, string>
  }